import React, { memo, useEffect, useState } from "react";
import stylesPc from "./SlideViewer.module.css";
import stylesSp from "./SlideViewer_SP.module.css";
import styleIpad from "./SlideViewer_IP.module.css";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import { pdfjs } from "react-pdf";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react"; //カルーセル用のタグをインポート
import SlideFullScreenPage from "./SlideFullScreenPage";
//ToDo
import VideoMetaDataPanel from "./metaData/VideoInfoPanel";
import VideoSuggestionsPanel from "./suggestions/VideoSuggestionsPanel";
import VideoDocument from "../../../pages/vod/Common/VideoDocument";
import { useDispatch, useSelector } from "react-redux";
import {
    GetSlideById,
    GetSlidePageCount,
    GetSlidePreviewImageUrl,
    ResetSlideInfo,
} from "../../../store/actions/SlideActions";
import { AppState } from "../../../root/RootReducer";
import { useLocation } from "react-router";
import EditSldieStock from "./slideStockEdit/EditSlideStock";
import { useInitFlag } from "../../../components/function/useInitFlag";
import { SaveDocumentStatistics } from "../../../store/actions/StatisticsActions";
import { makeTagStr } from "../../../utils/ObjectUtils";
import SlideCommentPanel from "./comments/SlideCommentPanel";

/**
|--------------------------------------------------
| スライド再生画面
|--------------------------------------------------
*/

SwiperCore.use([Navigation]);
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
function SlideViewer() {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : IsDevice("ipad") ? styleIpad : stylesSp;

    /* 
    共通情報
    */
    const dispatch = useDispatch();
    const location = useLocation();
    const [slideId, setSlideId] = useState(0);

    //ToDoユーザー情報
    const { user, slide, slidePageCount, slidePreviewImageUrl } = useSelector(
        (state: AppState) => ({
            user: state.user.user,
            slide: state.slide.slide,
            slidePageCount: state.slide.slidePageCount,
            slidePreviewImageUrl: state.slide.slidePreviewImageUrl,
        })
    );

    const [isEditing, setIsEditing] = useInitFlag();
    // 統計情報保存
    const [isSaveedStatistics, setSavedStatistics] = useInitFlag();
    //コンテンツ情報取得する為、現在表示されるコンテンツIDをURLから取得
    useEffect(() => {
        setSlideId(Number(location.pathname.substring(location.pathname.lastIndexOf("/") + 1)));
    }, [location, setSlideId]);

    /*
    プレビュー
    */

    // コンテンツ詳細情報リセット
    useEffect(() => {
        if (slideId !== slide?.id) {
            dispatch(ResetSlideInfo());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ファイルのページ合計数
    const [numPages, setNumPages] = useState(0);
    useEffect(() => {
        if (slidePageCount > 0) setNumPages(slidePageCount);
    }, [slidePageCount]);

    // コンテンツ詳細情報取得
    useEffect(() => {
        //コンテンツ詳細情報をコンテンツIDで取得
        if (slideId !== null && slideId !== 0 && user && !slide) {
            dispatch(GetSlideById(Number(user.id), slideId));
        }

        //ファイルの合計ページ数の設定
        if (slideId !== null && slide !== undefined && slide.fileName) {
            if (slidePageCount === 0) {
                dispatch(GetSlidePageCount(slideId, slide.fileName));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, slide, slideId, user]);

    // スライドプレビュー画像URL取得
    useEffect(() => {
        if (slidePageCount > 0) {
            if (slidePreviewImageUrl.length < slidePageCount) {
                if (slide) {
                    dispatch(
                        GetSlidePreviewImageUrl(
                            slide.id,
                            slide.fileName,
                            slidePreviewImageUrl.length + 1
                        )
                    );
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slidePageCount, slidePreviewImageUrl]);

    // 選択ページの変数設定
    const [pageNumber, setPageNumber] = useState(1);

    //pathからpage数指定
    useEffect(() => {
        if (
            location.search !== "" &&
            slidePreviewImageUrl.length > Number(location.search.substr(12)) - 1
        ) {
            setPageNumber(Number(location.search.substr(12)));
        }
    }, [slidePreviewImageUrl, location]);

    // 選択ページを変更
    const changePage = (offset: number) => {
        setPageNumber(pageNumber + offset);
    };

    // 選択ページを1ページ前に設定
    const handleClickPreviousPage = () => {
        if (slidePreviewImageUrl.length > 0) {
            if (pageNumber > 1) {
                changePage(-1);
                if (currentSwiper) {
                    currentSwiper.slideTo(pageNumber - 2);
                }
            }
        }
        //チャプタエリア自動スクロール
        handleChapterScroll(pageNumber);
    };

    // 選択ページを1ページ後に設定
    const handleClickNextPage = () => {
        if (slidePreviewImageUrl.length > pageNumber) {
            if (pageNumber < numPages) {
                changePage(1);
                if (currentSwiper) {
                    currentSwiper.slideTo(pageNumber);
                }
            }
        }
        //チャプタエリア自動スクロール
        handleChapterScroll(pageNumber);
    };

    /*
    スライドグループ
    */

    //ページグループ
    const [currentSwiper, setCurrentSwiper] = useState<null | SwiperCore>(null);

    //ページグループエリアの右左アイコンの設定
    const navigationPrevRef = React.useRef(null);
    const navigationNextRef = React.useRef(null);

    // 現在表示されているページグループの設定
    const onSwiper = (swiper: SwiperCore) => {
        setCurrentSwiper(swiper);
    };

    //スライドグループ画像をクリック
    const handleSlideGroupClick = (index: number) => {
        //現在ページ番号設定
        setPageNumber(index);
        //チャプタエリア自動スクロール
        handleChapterScroll(index);
    };

    /*
     Tips
    */

    //infoアイコンにマウス入る処理
    const MouseEnterInfo = () => {
        const commentArea = document.getElementById("commentArea");
        if (commentArea) {
            commentArea.style.visibility = "visible";
        }
    };

    //infoアイコンにマウス出る処理
    const MouseLeaveInfo = () => {
        const commentArea = document.getElementById("commentArea");
        if (commentArea) {
            commentArea.style.visibility = "hidden";
        }
    };

    //シェアアイコンを押下する場合
    // const handleClickShareIcon = () => {
    //     const url = window.location.toString();
    //     if (url.includes("?")) {
    //         navigator.clipboard.writeText(url.substring(0, url.indexOf("?")));
    //     } else {
    //         navigator.clipboard.writeText(window.location.toString());
    //     }
    // };

    //チャプターを押下する場合
    const handleChapterClick = (title: number) => {
        //現状表示ページをチャプターのタイトルに設定
        setPageNumber(title);
        if (currentSwiper) {
            currentSwiper.slideTo(title - 1);
        }
    };

    //チャプタエリアスクロール
    const handleChapterScroll = (title: number) => {
        //チャプタのmain div
        const mainChapterDiv = document.getElementById("chapterArea");
        //サブチャプタdiv
        const subChapterDiv = document.getElementById(`subChapter${title}`);

        if (mainChapterDiv !== null && subChapterDiv !== null) {
            const mainChapterTopPos = mainChapterDiv.offsetTop;
            const subChapterTopPos = subChapterDiv.offsetTop;
            const diffTopPos = subChapterTopPos - mainChapterTopPos;
            if (diffTopPos < 300) {
                mainChapterDiv.scrollTop = 0;
            } else {
                mainChapterDiv.scrollTop = diffTopPos;
            }
        }
    };

    // キーコードを判定して該当処理を呼び出す
    const keyDownFun = (event: any) => {
        if (!isEditing) {
            switch (event.keyCode) {
                case 32:
                    event.preventDefault();
                    break;
                // ←キーでスライドプレビューの移動（1ページずつ前）
                case 37:
                    event.preventDefault();
                    handleClickPreviousPage();
                    break;
                // →キーでスライドプレビューの移動（1ページずつ先）
                case 39:
                    event.preventDefault();
                    handleClickNextPage();
                    break;
            }
        }
    };

    const [isUnderlKeyBorardControl, setIsUnderlKeyBorardControl] = useState<boolean>(true);
    useEffect(() => {
        if (isUnderlKeyBorardControl) {
            document.addEventListener("keydown", keyDownFun);
        } else {
            document.removeEventListener("keydown", keyDownFun);
        }
        return () => {
            document.removeEventListener("keydown", keyDownFun);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [[], pageNumber, isUnderlKeyBorardControl]);

    // 統計データを保存する。
    useEffect(() => {
        if (user && pageNumber && slide && !isSaveedStatistics) {
            dispatch(
                SaveDocumentStatistics(
                    Number(user.id),
                    slide.id,
                    makeTagStr(slide.tags),
                    slide.title,
                    slide.imageUrl
                )
            );
            setSavedStatistics(true);
        }
        // eslint-disable-next-line
    }, [user, pageNumber, slide]);

    return (
        <>
            {/* Main Conitainer */}
            <div className={styles.mainPannel}>
                {/* 左枠 */}
                <div className={styles.leftPannel}>
                    {/* プレビュー枠*/}
                    <div className={styles.pagePreview}>
                        {/* Slide編集ボタン表示 */}
                        {IsDevice("desktop") && (
                            <div className={styles.editSlideBtnDiv}>
                                <EditSldieStock slideId={slideId} setIsEditing={setIsEditing} />
                            </div>
                        )}
                        {/* プレビュー画像表示枠 */}
                        <div className={styles.pageArea}>
                            {/* プレビュー画像枠 */}
                            <div className={styles.previewImage}>
                                {slidePreviewImageUrl.length > 0 && (
                                    <img
                                        src={slidePreviewImageUrl[pageNumber - 1]?.imageUrl}
                                        className={styles.pagePosition}
                                        alt=""
                                    />
                                )}
                            </div>
                            {/* Tipsアイコン表示エリア */}
                            {slide !== undefined &&
                                slide.tips.length > 0 &&
                                slide.tips.find((tip) => Number(tip.title) === pageNumber) && (
                                    <div
                                        className={styles.infoIcon}
                                        onMouseEnter={MouseEnterInfo}
                                        onMouseLeave={MouseLeaveInfo}
                                    >
                                        <img
                                            src={require("../../../assets/image/info.svg")}
                                            onMouseOver={(e) =>
                                                (e.currentTarget.src = require("../../../assets/image/info_hover.svg"))
                                            }
                                            onMouseOut={(e) =>
                                                (e.currentTarget.src = require("../../../assets/image/info.svg"))
                                            }
                                            alt="linkIcon"
                                            className={styles.iconStyle}
                                        />
                                    </div>
                                )}
                            {/* 管理者コメント表示エリア */}
                            <div
                                id="commentArea"
                                style={{ visibility: "hidden" }}
                                className={styles.adminCommentArea}
                            >
                                {slide !== undefined &&
                                    slide.tips
                                        .filter((tip) => Number(tip.title) === pageNumber)
                                        .map((tip) => tip.description)}
                            </div>
                        </div>
                    </div>
                    {/* Pagination枠 */}
                    <div className={styles.paginArea}>
                        {/* pagin真ん中エリア */}
                        <div className={styles.pageNumberDiv}>
                            <div className={styles.paginCenterArea}>
                                {/* leftArrowエリア */}
                                <div className={styles.leftArrowArea}>
                                    <img
                                        src={require("../../../assets/image/left.svg")}
                                        onMouseOver={(e) =>
                                            (e.currentTarget.src = require("../../../assets/image/left_hover.svg"))
                                        }
                                        onMouseOut={(e) =>
                                            (e.currentTarget.src = require("../../../assets/image/left.svg"))
                                        }
                                        alt="leftIcon"
                                        className={styles.iconStyleLeftArrow}
                                        onClick={handleClickPreviousPage}
                                    />
                                </div>
                                {/* PageNumberエリア */}
                                <div className={styles.pageNumberArea}>
                                    {pageNumber}/{numPages}
                                </div>
                                {/* rightArrowエリア */}
                                <div className={styles.rightArrowArea}>
                                    <img
                                        src={require("../../../assets/image/right.svg")}
                                        onMouseOver={(e) =>
                                            (e.currentTarget.src = require("../../../assets/image/right_hover.svg"))
                                        }
                                        onMouseOut={(e) =>
                                            (e.currentTarget.src = require("../../../assets/image/right.svg"))
                                        }
                                        alt="rightIcon"
                                        className={styles.iconStyleRightArrow}
                                        onClick={handleClickNextPage}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={styles.iconDiv}>
                            {/* シェアアイコン */}
                            {/*
                            <div className={styles.shareIconArea}>
                                <img
                                    src={require("../../../assets/image/share.svg")}
                                    // onMouseOver={(e) =>
                                    //     (e.currentTarget.src = require("../../../assets/image/share_hover_toggle.svg"))
                                    // }
                                    // onMouseOut={(e) =>
                                    //     (e.currentTarget.src = require("../../../assets/image/share.svg"))
                                    // }
                                    alt="shareIcon"
                                    className={styles.iconStyleShare}
                                    onClick={handleClickShareIcon}
                                />
                            </div>
                            */}
                            {/* ダウンロードアイコン */}
                            {/*
                            <div className={styles.downloadIconArea}>
                                <img
                                    src={require("../../../assets/image/download.svg")}
                                    // onMouseOver={(e) =>
                                    //     (e.currentTarget.src = require("../../../assets/image/download_hover_toggle.svg"))
                                    // }
                                    // onMouseOut={(e) =>
                                    //     (e.currentTarget.src = require("../../../assets/image/download.svg"))
                                    // }
                                    alt="download"
                                    className={styles.iconStyleDownload}
                                />
                            </div>
                            */}

                            {/* FullScreenアイコン */}
                            <SlideFullScreenPage
                                pageNumber={pageNumber}
                                setPageNumber={setPageNumber}
                                currentFilePreviewImage={slidePreviewImageUrl}
                            />
                        </div>
                    </div>
                    {/* 画像リスト枠 */}
                    <div className={styles.pageSlideArea}>
                        <div className={styles.pagePreviewLeftLarge}>
                            <div ref={navigationPrevRef}>
                                <img
                                    src={require("../../../assets/image/left2.svg")}
                                    onMouseOver={(e) =>
                                        (e.currentTarget.src = require("../../../assets/image/left2_hover.svg"))
                                    }
                                    onMouseOut={(e) =>
                                        (e.currentTarget.src = require("../../../assets/image/left2.svg"))
                                    }
                                    alt="leftArrowIcon"
                                    className={styles.iconStyle}
                                />
                            </div>
                        </div>
                        <div className={styles.pageSlidelist}>
                            <Swiper
                                onSwiper={(swiper) => onSwiper(swiper)}
                                spaceBetween={5}
                                slidesPerGroup={5}
                                slidesPerView={5}
                                navigation={{
                                    prevEl: navigationPrevRef.current,
                                    nextEl: navigationNextRef.current,
                                }}
                                className={styles.swiperContainer}
                            >
                                {slidePreviewImageUrl.map((image, index: number) => (
                                    <SwiperSlide
                                        key={image.sequence}
                                        className={
                                            Number(pageNumber) !== index + 1
                                                ? styles.slide
                                                : styles.swiperSlide
                                        }
                                        onClick={() => {
                                            handleSlideGroupClick(index + 1);
                                        }}
                                    >
                                        <img
                                            src={image.imageUrl}
                                            alt=""
                                            className={styles.slideImage}
                                            onMouseOver={(e) =>
                                                (e.currentTarget.src = image.imageUrl)
                                            }
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                        <div className={styles.pagePreviewRightLarge}>
                            <div ref={navigationNextRef}>
                                <img
                                    src={require("../../../assets/image/right2.svg")}
                                    onMouseOver={(e) =>
                                        (e.currentTarget.src = require("../../../assets/image/right2_hover.svg"))
                                    }
                                    onMouseOut={(e) =>
                                        (e.currentTarget.src = require("../../../assets/image/right2.svg"))
                                    }
                                    alt="rightArrowIcon1"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/* 左枠*/}
                <div className={styles.rightPannel}>
                    {/* チャプター枠のヘッダー */}
                    <div className={styles.chapterHeaderArea}>
                        <img
                            src={require("../../../assets/image/index.svg")}
                            alt="indexIcon"
                            className={styles.righticonStyle}
                        />
                        Index
                    </div>
                    {/* チャプター内容枠 */}
                    <div className={styles.chapterArea} id="chapterArea">
                        {slide !== undefined &&
                            slide.chapter != null &&
                            slide.chapter.map((chapter) => (
                                <div
                                    id={`subChapter${chapter.title}`}
                                    key={chapter.id}
                                    onClick={() => handleChapterClick(chapter.title)}
                                    className={
                                        chapter.title === pageNumber
                                            ? styles.activeChapterSubDiv
                                            : styles.chapterSubDiv
                                    }
                                >
                                    <div>P. {chapter.title}</div>
                                    <div>{chapter.description}</div>
                                </div>
                            ))}
                    </div>
                    {/* リンク枠 */}
                    {/* <div className={styles.linkDiv}>
                        <div className={styles.linkHeaderArea}>
                            <img
                                src={require("../../../assets/image/link.svg")}
                                alt="linkIcon"
                                className={styles.righticonStyle}
                            />
                            LINK
                        </div>
                        {slide !== undefined &&
                            slide.links !== undefined &&
                            slide.links.length > 0 &&
                            slide.links.find((Link) => Number(Link.title) === pageNumber) && (
                                <div className={styles.linkSubDiv}>
                                    {slide.links
                                        .filter((link) => Number(link.title) === pageNumber)
                                        .map((link) => (
                                            <a
                                                href={link.link}
                                                rel="noopener noreferrer"
                                                target="_blank"
                                                className={styles.slideLink}
                                            >
                                                {link.link}
                                            </a>
                                        ))}
                                </div>
                            )}
                    </div> */}
                </div>
                {/* メタデータマイン枠 */}
                <div className={styles.metaMainPannel}>
                    {/* 左メタデータ枠 */}
                    <div className={styles.metaleftPannel}>
                        {/* 詳細情報表示 */}
                        <div>{slide && <VideoMetaDataPanel video={slide} />}</div>
                        {/* 資料情報枠 */}
                        <div className={styles.materials}>
                            {slide && (
                                <VideoDocument
                                    documentList={slide.extraMaterials}
                                    contentType={"slidestock"}
                                />
                            )}
                        </div>
                        <div className={styles.comments}>
                            {slide && (
                                <SlideCommentPanel
                                    pageNumber={pageNumber}
                                    setPageNumber={setPageNumber}
                                    documentId={slide.id}
                                    setIsUnderlKeyBorardControl={setIsUnderlKeyBorardControl}
                                />
                            )}
                        </div>
                    </div>
                    {/* お勧めビデオ枠 */}
                    <div className={styles.metaRightPannel}>
                        {slide && <VideoSuggestionsPanel />}
                    </div>
                </div>
            </div>
        </>
    );
}

export default memo(SlideViewer);
